{
  "evaluationPublished": "La evaluación de {{respondentEmail}} está lista",
  "evaluationReady": "Tu evaluación de {{tenantName}} está lista",
  "selfProfileReady": "Tu perfil está listo para comenzar",
  "assignmentsSent": "Tus cuestionarios se han enviado",
  "creditsReady": "Tus créditos están listos",
  "view": "Ver",
  "start": "Comenzar"
}
